export const RIDER_STATUSES: { [key: string]: string } = {
  DELIVERED_BY_RIDER: 'Delivered',
  RETURNED_BY_RIDER: 'Returned',
  PARTIALLY_DELIVERED_BY_RIDER: 'Partial Del',
  ON_DELIVERY: 'On Delivery',
};

export function MobileNo(mobile_no: string = '') {
  if (mobile_no && mobile_no.includes(',')) {
    return mobile_no.split(',').map((num, i) => {
      num = num.trim();
      if (num.length === 11) {
        return (
          <span>
            {num}
            <br />
          </span>
        );
      } else {
        return (
          <span>
            ,<span style={{ color: 'red', textDecoration: 'line-through' }}>{num}</span>
          </span>
        );
      }
    });
  } else {
    return mobile_no && mobile_no.trim().length === 11 ? (
      mobile_no
    ) : (
      <span style={{ color: 'red', textDecoration: 'line-through' }}>{mobile_no}</span>
    );
  }
}
